import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  spacingRight: {
    marginRight: theme.spacing(2)
  },
  stepperRoot: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));